import React from 'react';

const ChatMessage = ({ message }) => {
    const isUser = message.sender === 'user';

    // Fonction pour mettre en gras le texte entre **étoiles**
    const formatText = (text) => {
        if (!text) return null;
        // On sépare le texte par les blocs **...**
        const parts = text.split(/(\*\*.*?\*\*)/g);
        
        return parts.map((part, index) => {
            if (part.startsWith('**') && part.endsWith('**')) {
                // On enlève les étoiles et on met en gras
                return <strong key={index} className="font-bold">{part.slice(2, -2)}</strong>;
            }
            return part;
        });
    };

    return (
        <div className={`flex w-full ${isUser ? 'justify-end' : 'justify-start'} mb-6 animate-fade-in`}>
            
            <div
                className={`
                    relative text-base md:text-lg leading-relaxed
                    max-w-[85%] md:max-w-[80%] 
                    break-words whitespace-pre-wrap
                    ${isUser 
                        ? 'bg-[#E6D4A8] text-[#1c2143] px-5 py-3.5 rounded-2xl rounded-tr-sm shadow-sm' // User : Doré, texte bleu
                        : 'bg-transparent text-gray-800 p-0 shadow-none border-none' // ✅ Bot : 100% Transparent, pas d'ombre
                    }
                `}
            >
                {/* On utilise notre fonction de formatage au lieu d'afficher le texte brut */}
                {formatText(message.text)}
            </div>
        </div>
    );
};

export default ChatMessage;